export type ScreenId =
  | "selectMode"
  | "downloadCreateTemplate"
  | "downloadUpdateTemplate"
  | "loadCSV"
  | "uploadCSV"
  | "complete";

export type CSVImportUIScreenTitles = Partial<Record<ScreenId, string>>;

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ScreenProps {}
